import { cn } from '#/lib/utils'

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export default function Container({ children, className, ...props }: ContainerProps) {
  return (
    <div className={cn('mx-auto max-w-6xl px-4 sm:px-6 lg:px-8', className)} {...props}>
      {children}
    </div>
  )
}
